// // Функция для определения мобильного устройства
// // function isMobileDevice() {
// //   return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
// // }

// // Функция для показа формы обратного звонка
// function showCallbackForm() {
//   const modalHTML = document.getElementById('partnersModal')

//   document.body.insertAdjacentHTML('beforeend', modalHTML);

//   const modal = document.querySelector('.callback-modal');
//   // const closeButton = modal.querySelector('.callback-form__close');
//   const form = modal.querySelector('#callbackForm');
//   const phoneInput = form.querySelector('input[name="phone"]');

//   // Обработчик закрытия модального окна
//   document.body.addEventListener('click', (e) => {
//     if (e.target.closest('.callback-form__close')) {
//       // console.log('Кнопка закрытия нажата через делегирование');
//       e.target.closest('.callback-modal').remove();
//     }
//   });

//   // Добавление маски для телефона
//   if (typeof IMask !== 'undefined') {
//     IMask(phoneInput, {
//       mask: '+{7}(000)000-00-00'
//     });
//   }

//   form.addEventListener('submit', function(e) {
//     e.preventDefault();
//     const formData = new FormData(form);
//     console.log('Форма отправлена:', Object.fromEntries(formData));
//     alert('Спасибо за заявку! Мы свяжемся с вами в ближайшее время.');
//     // modal.remove();
//   });
// }

// // Добавляем обработчики событий при загрузке DOM
// document.addEventListener('DOMContentLoaded', () => {
//   const phoneElement = document.querySelector('.partners-page__order-call');
//   const callbackLink = document.querySelector('.partners-page__phone-link');

//   if (phoneElement && callbackLink) {
//     if (isMobileDevice()) {
//       // На мобильных устройствах
//       phoneElement.innerHTML = `<a href="tel:${phoneElement.textContent.replace(/\s/g, '')}">${phoneElement.textContent}</a>`;
//       callbackLink.style.display = 'none'; // Скрываем ссылку "заказать звонок" на мобильных
//     } else {
//       // На ПК
//       phoneElement.addEventListener('click', (e) => {
//         e.preventDefault();
//         showCallbackForm();
//       });
//       callbackLink.addEventListener('click', (e) => {
//         e.preventDefault();
//         showCallbackForm();
//       });
//     }
//   }
// });

function toggleModal() {
  const modal = document.getElementById('partnersModal');

  if (modal) {

  if (modal.style.display === 'none' || modal.style.display === '') {
    modal.style.display = 'flex';
    setTimeout(() => {
      modal.style.opacity = '1';
    }, 10);
  } else {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.style.display = 'none';
    }, 500);
  }
}

function setupForm() {
  const form = document.getElementById('callbackForm');
  const phoneInput = form.querySelector('input[name="phone"]');

  // Добавление маски для телефона
  if (typeof IMask !== 'undefined') {
    IMask(phoneInput, {
      mask: '+{7}(000)000-00-00'
    });
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const formData = new FormData(form);
    const data = Object.fromEntries(formData);

    // Отправка данных на API
    fetch('https://example.com/api/callback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(data => {
      console.log('Успех:', data);
      alert('Спасибо за заявку! Мы свяжемся с вами в ближайшее время.');
      setTimeout(() => {
        toggleModal();
      }, 500);
    })
    .catch((error) => {
      console.error('Ошибка:', error);
      alert('Произошла ошибка при отправке данных. Пожалуйста, попробуйте позже.');
    });
  });
}

// Инициализируем форму после загрузки страницы
document.addEventListener('DOMContentLoaded', setupForm);

}